import React from 'react';

// Breadcrumb + title + subtitle for kebab-accessed "detail" pages (e.g.
// Products / SP400 / Prices) — piloted on ProductPricesPage.js, then rolled
// out wherever a page is reached via a kebab rather than direct navigation.
// crumbs: [{ label, onClick }] — omit onClick on the last (current) crumb.
function PageHeader({ crumbs, title, note, subtitle, meta }) {
  return (
    <>
      <div style={{ fontSize: 15, color: '#666', marginBottom: 12 }}>
        {crumbs.map((crumb, i) => (
          <React.Fragment key={crumb.label}>
            {i > 0 && <span style={{ margin: '0 6px', color: '#bbb' }}>/</span>}
            {crumb.onClick ? (
              <button type="button" className="link-button" onClick={crumb.onClick} style={{ fontSize: 15 }}>{crumb.label}</button>
            ) : i === crumbs.length - 1 ? (
              <strong style={{ color: '#333' }}>{crumb.label}</strong>
            ) : (
              <span>{crumb.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>
      <h2 style={{ margin: '0 0 4px', fontWeight: 700, fontSize: 24 }}>{title}</h2>
      {note && <div style={{ color: '#8a97ab', fontSize: 13, marginBottom: 8 }}>{note}</div>}
      {subtitle && <div style={{ color: '#666', fontSize: 14, marginBottom: meta ? 4 : 20 }}>{subtitle}</div>}
      {meta && <div style={{ color: '#666', fontSize: 14, marginBottom: 20 }}>{meta}</div>}
    </>
  );
}

export default PageHeader;
